/**
 * The Roundup — English copy.
 *
 * LANGUAGE RED LINE (spec §1, §10.1):
 *   Approved:   hit / hitter / host / book / tonight's rate
 *   Forbidden:  lesson / coach / teach / session / trainer /
 *               tuition / provider / student / class
 *
 * If you edit this file, DO NOT introduce any forbidden terms.
 * A repo-level lint (docs/roundup-vocab.md) checks these strings.
 */
export const roundup = {
  brand: "The Roundup",
  boardTitle: "The Roundup — who's on now",
  tagline: "No partner? Book a hit. Got time? Host one.",

  sections: {
    free: "Free hits",
    paid: "Paid hits",
    empty: "Nobody's up right now — host a hit and set your rate.",
  },

  statuses: {
    off: "Off",
    free: "Free hit",
    paid: "Hosting (paid)",
  },

  actions: {
    hostHit: "Host a hit",
    bookHit: "Book a hit",
    findHit: "Find a hit",
    goOffline: "Go offline",
    setRate: "Set your rate",
    accept: "Accept",
    decline: "Decline",
    cancel: "Cancel",
    complete: "Mark as played",
    dispute: "Report an issue",
    review: "Leave a review",
  },

  card: {
    tonightsRate: "Rate",
    freeLabel: "FREE",
    perHour: "/ hr",
    ratingVerified: "Verified",
    ratingProvisional: "Provisional",
    recentPrice: "Recent: {{low}}–{{high}}",
    sameGenderOnly: "Same gender only",
    completedOrders: "{{count}} hits completed",
    stars: "{{stars}} ({{count}})",
  },

  hostingModal: {
    title: "Host a hit",
    modeLabel: "Mode",
    modeFree: "Free hit",
    modeFreeSub: "Same-level, no payment. Split court fees.",
    modePaid: "Paid hit",
    modePaidSub: "Set your rate. Platform takes 20%.",
    rateLabel: "Your rate",
    ratePlaceholder: "Min $15/hr",
    rateHelper: "You set it every time you go online. No permanent price.",
    bioLabel: "Short intro (optional)",
    bioPlaceholder: "One line about your game",
    areasLabel: "Areas you'll play",
    areasPlaceholder: "e.g. Downtown, Southgate",
    expiresLabel: "Auto-offline",
    expiresTonight: "End of today",
    sameGenderLabel: "Only accept same-gender bookings",
    inSeasonGate: {
      title: "Paid hosting is In-Season only",
      body:
        "To host paid, play {{min}} verified matches in the last {{days}} days. You've played {{played}} so far.",
      cta: "Go Free instead",
    },
    submit: "Go online",
    saving: "Going online…",
  },

  bookingModal: {
    title: "Book this hit",
    proposedTime: "When?",
    proposedDate: "Date",
    proposedStart: "Start",
    proposedEnd: "End",
    courtLabel: "Court",
    courtPlaceholder: "Where will you play?",
    noteLabel: "Note (optional)",
    notePlaceholder: "Say hi, mention preferences (140 chars)",
    fee: "Platform fee (20%)",
    total: "Total charged now",
    escrowNote:
      "Card is authorized now. Money moves after they accept and you play.",
    submitFree: "Send request",
    submitPaid: "Book & authorize",
    submitting: "Sending…",
  },

  order: {
    statusRequested: "Awaiting hitter",
    statusConfirmed: "Confirmed — see you at the court",
    statusCompleted: "Played",
    statusCancelled: "Cancelled",
    statusExpired: "Expired (no response in 24h)",
    statusDisputed: "Under review",
    autoCompleteHint: "Auto-completes 24h after your slot.",
    contactUnlocked: "Contact unlocked — see below",
  },

  policies: {
    cancelFull: "Free cancel until 12h before the hit.",
    cancelPartial:
      "Inside 12h: buyer gets 50% back, hitter keeps 45%, platform 5%.",
    hitterCancel:
      "If the hitter cancels: full refund to you. Two cancels in a row suspends their listing for 7 days.",
  },

  review: {
    prompt: "Rate your hit",
    starsLabel: "Stars",
    bodyLabel: "One line ({{n}}/140)",
    submit: "Submit review",
    skip: "Skip",
    window: "You have 7 days to review.",
    onlyPaid: "Reviews are for paid hits only.",
  },

  compliance: {
    nonTeaching:
      "Hitters play with you, not teach you. This isn't a lesson.",
    payoutTerms: "20% platform fee. That's it. No hidden costs.",
    waiver: "By booking you agree to Acework's participant waiver.",
    courtRequired: "Public court or club only. Both parties must agree.",
  },

  founding: {
    badge: "Founding Hitter",
    tooltip: "Seed hitter — free league entry.",
    obligation: "Founding Hitters play 3+ verified matches per season.",
  },
};
